export const preGameErrorReasonEnum = {
  MAINTENANCE: 'maintenance',
  ZERO_BALANCE: 'zero_balance',
};

export const gameThemeEnum = {
  NO_CATEGORY: 'NO_CATEGORY',
  ALL: 'ALL',
  SEASONAL: 'SEASONAL',
};

export const gameCategoryEnum = {
  MUSIC: 'MUSIC',
  CINEMA_TV: 'CINEMA_TV',
  ARTS: 'ARTS',
  CELEBS: 'CELEBS',
  BUSINESS: 'BUSINESS',
  ATHLETES: 'ATHLETES',
  SCIENCE: 'SCIENCE',
  LEADERS: 'LEADERS',
  HISTORICAL: 'HISTORICAL',
  LOCAL: 'LOCAL',
  CUSTOM: 'CUSTOM',
  RANDOM: 'RANDOM',
};

export const gameJokerTypeEnum = {
  FIFTY_FIFTY: 'FIFTY_FIFTY',
  CHEAT: 'CHEAT',
};

export const bonusGameTypeEnum = {
  BONUS_GAME_PUZZLE: 'bonus_game_puzzle',
  BONUS_GAME_LANTERNS: 'bonus_game_lanterns',
};
